module.exports = __webpack_public_path__ + "img/team-1.d438dd5f.jpg";